
import CustomerStories from '@/components/widgets/CustomerStories';
import QuestionSection from '@/components/widgets/QuestionSection';
import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import ShopByShape from './ShopByShape';
import JewelryShowcase from './JewelryShowcase';
import RingsMenu from './RingsMenu';
import {
  ConnectionSpeed,
  useMeasureConnectionSpeed,
} from '@/custom_hooks/useMeasureConnectionSpeed';
import EternityBandsHero2 from './EternityBands1';
import VertelierExperienceEngagement from '@/components/widgets/VertelierExperienceEngagement';
import { useProductsByParam } from '@/hooks/useProducts';
import ProposalImageAnim from './ProposalImageAnim';
import CalendlyEmbed from '@/components/widgets/CalendlyEmbed';
import Loading from '@/components/widgets/Loading';
import { useUser } from '@/components/widgets/UserProvider';
import ProductCardGridWithVideo from '@/components/widgets/ProductCardGridWithVideo';
import TagButton from '../../home-page/home-page-widgets/TagButton';
import { useRouter } from 'next/navigation';
import { FetchProductParams } from '@/helpers/types/params_body/FetchProductParams';
// import LoveSection from '@/components/widgets/LoveSection';

//import dynamic from 'next/dynamic';
const LoveSection = dynamic(() => import('@/components/widgets/LoveSection').then(mod => mod.LoveSection), {
  ssr: false,
});


const HeroSection = () => {
  const router = useRouter();
  const [activeTab, setActiveTab] = useState({
    id: 'Simply',
    label: ['', 'Solitaires'],
    redirect: { subcategory: 'VERI3' },
  });

  const params: FetchProductParams = {
    // main_category: 'Rings',
    subcategory: 'VERI3',
    karat:"10"
  };

  const [query, setQuery] = useState(params);

  const { userPageLoading } = useUser();

  const {
    products: productList,
    isLoading,
    isError,
  } = useProductsByParam(query);

  const paramsInStock: FetchProductParams = {
    // main_category: 'Rings',
    // subcategory: 'VERI',
    main_category: 'Rings',
    subcategory: 'Instock',
  };

  const {
    products: productListStock,
    isLoading: loading,
    isError: errorInStock,
  } = useProductsByParam(paramsInStock);
  const handleTabPress = (item: any) => {
    setQuery(item?.redirect);
    setActiveTab(item);
  };

  const [videoUrl, setVideoUrl] = useState<string>('');
  const [isOpen, setOpen] = useState(false);
  const { speedKbps, speedCategory } = useMeasureConnectionSpeed();

  useEffect(() => {
    // let isMounted = true; // Flag to track if component is mounted

    if (speedCategory) {
      let qualityUrl = '';

      switch (speedCategory) {
        case ConnectionSpeed.VERY_LOW:
          qualityUrl =
            'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Engagement_Page/home_page_banner_very_low.mp4';
          break;
        case ConnectionSpeed.LOW:
          qualityUrl =
            'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Engagement_Page/home_page_banner_low.mp4';
          break;
        case ConnectionSpeed.MEDIUM:
          qualityUrl =
            'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Engagement_Page/home_page_banner_medium.mp4';
          break;
        case ConnectionSpeed.HIGH:
          qualityUrl =
            'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Engagement_Page/home_page_banner_high.mp4';
          break;
        default:
          qualityUrl =
            'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Engagement_Page/home_page_banner_low.mp4';
      }

      setVideoUrl(qualityUrl);
    }
  }, [speedCategory]);

  const [isMuted, setIsMuted] = useState(true);

  const handleTouchToggleMute = () => {
    setIsMuted((prevState) => {
      const newState = !prevState;
      // console.log(newState ? 'Muted the video' : 'Unmuted the video');
      return newState;
    });
  };
  return (
    <>
     {videoUrl ? <LoveSection videoUrl={videoUrl} />:null}


      <div className='flex flex-col justify-center items-center py-4 sm:py-8 mt-8 sm:mt-0 mb-4 md:mb-8'>
        {userPageLoading ? (
          <>
            <Loading
              classes={
                'flex-grow flex relative max-h-screen h-[45px] mx-[15%] mt-[25px] bg-[rgba(128,128,128,0.3)] !text-white'
              }
            />
          </>
        ) : (
          <div className='flex'>
            <h1 className='text-[#A08260] font-cambonLight text-[24px] leading-[31px] md:text-[40px] md:leading-[40px] lg:text-[40px] lg:leading-[83px] text-center'>
              Shop By
              <span className=' font-cambonExtraLightItalic'> Shape</span>
            </h1>
          </div>
        )}
        {userPageLoading ? (
          <>
            <Loading
              classes={
                'flex-grow flex relative max-h-screen sm:min-h-[30px] mx-[30%] bg-[rgba(128,128,128,0.3)] !text-white'
              }
            />
            <Loading
              classes={
                'flex-grow flex relative max-h-screen sm:min-h-[55px] my-[10px] mx-[20%] bg-[rgba(128,128,128,0.3)] !text-white'
              }
            />
            <Loading
              classes={
                'flex-grow flex relative max-h-screen sm:min-h-[30px] mx-[30%] bg-[rgba(128,128,128,0.3)] !text-white'
              }
            />
          </>
        ) : (
         <ShopByShape />
        )}
      </div>

     <JewelryShowcase />


     <ProposalImageAnim />

     <RingsMenu onTabPress={handleTabPress} activeTab={activeTab} />

      <div className='mt-16'>
        {userPageLoading ? (
          <Loading
            classes={
              'flex-grow flex relative max-h-screen sm:min-h-[45px] mx-[43%] justify-center bg-[rgba(128,128,128,0.3)] !text-white'
            }
          />
        ) : (
          <h1 className='font-cambonExtraLight text-[20px] switch:text-[24px] md:text-[30px] lg:text-[32px] text-center text-white'>
            {activeTab?.label[0]}
            <span className='font-cambonExtraLightItalic'>
              {' '}
              {activeTab?.label[1]}
            </span>
          </h1>
        )}

        <div className='flex justify-center sm:mt-[30px] mt-[10px] sm:mb-[0px] mb-[40px] px-2 sm:px-0'>
          <ProductCardGridWithVideo
            isLoading={isLoading}
            theme='black'
            productList={productList?.slice(0, 4) ?? []}
          />
        </div>

        {userPageLoading ? (
          <Loading
            classes={
              'flex-grow flex relative max-h-screen sm:min-h-[35px] mx-[40%] mb-[20px] bg-[rgba(128,128,128,0.3)] !text-white rounded-[35px]'
            }
          />
        ) : (
          <div className='flex justify-center lg:pb-8 pb-0 mt-5 mb-10'>
            <TagButton
              text='Shop all solitaire rings'
              onClick={() =>
                router.push(
                  `/product-listing?subcategory=Solitaire&main_category=Rings`
                )
              }
            />
          </div>
        )}
      </div>
      <EternityBandsHero2
        showLastBanner={false}
        btnClick='/product-listing?main_category=Rings&subcategory=Wedding%20Bands'
      />


      <CustomerStories />
      {/* Bridal section */}
      {/* {userPageLoading ? (
        <>
          <Loading
            classes={
              'flex-grow flex relative max-h-screen sm:min-h-[345px] mt-[10px] bg-[rgba(128,128,128,0.3)] !text-white'
            }
          />
          <Loading
            classes={
              'flex-grow flex relative max-h-screen sm:min-h-[45px] mx-[41%] justify-center mt-[10px] bg-[rgba(128,128,128,0.3)] !text-white'
            }
          />
          <Loading
            classes={
              'flex-grow flex relative max-h-screen sm:min-h-[85px] mx-[35%] justify-center mt-[10px] bg-[rgba(128,128,128,0.3)] !text-white'
            }
          />
          <div className='flex gap-4 justify-around mx-[30%] mb-[10px]'>
            <Loading
              classes={
                'flex-grow flex relative max-h-screen sm:min-h-[50px] mt-[10px] bg-[rgba(128,128,128,0.3)] !text-white rounded-[40px]'
              }
            />
            <Loading
              classes={
                'flex-grow flex relative max-h-screen sm:min-h-[50px] mt-[10px] bg-[rgba(128,128,128,0.3)] !text-white rounded-[40px]'
              }
            />
          </div>
        </>
      ) : (
        <div className='w-full grid items-center justify-center bg-white pb-[97px]'>
        //    <h2 className="text-black font-inter-400 text-[32px] sm:text-[50px] items-center text-center">
        //   Custom Bridal
        // </h2>

          <div>
            <Image
              src='/engagement/bridal-necklace-mobile.png'
              alt='big_ring'
              width={1440}
              height={837}
              className='md:hidden'
            />

            <Image
              src='/engagement/bridal-necklace.png'
              alt='big_ring'
              width={1440}
              height={837}
              className='hidden md:block'
            />
          </div>

          <div className='text-center'>
            <span className='font-barlowSemibold font-[500] md:text-[24px] lg:text-[24px] xlg:text-[24px] text-[12px] uppercase leading-[14px] md:leading-[28.8px] lg:leading-[28.8px] xlg:leading-[28.8px] text-black'>
              Every detail is sculpted
            </span>
          </div>

          <div className='text-center'>
            <span className='font-[400] text-[40px] md:text-[128px] lg:text-[128px] xlg:text-[128px] leading-[46.4px] md:leading-[148.48px] lg:leading-[148.48px] xlg:leading-[148.48px] text-[#330000] uppercase font-aboreto'>
              Bridal
            </span>
          </div>

          <div className='grid md:flex lg:flex xlg:flex justify-center gap-[24px]'>
            <button
              className='uppercase md:py-[9px] sm:py-[8px] py-[7px] lg:py-[11px] ps-[8px] pe-[15px] rounded-full border flex justify-center items-center group border-[#330000] text-[#330000]'
              onClick={() => setOpen(true)}
            >
              <div className=' h-5 w-5  items-center justify-center flex'>
                <div
                  className='h-1 w-1 rounded-full bg-white duration-300 ease-in-out justify-center items-center flex'
                  style={{ backgroundColor: '#330000' }}
                ></div>
              </div>
              <h1 className=' font-barlowSemibold tracking-widest ps-2 text-[11px] mb-sm:text-[12.5px] mb-md:text-[13.5px] mb-lg:text-[15px] lg:text-[16px]'>
                Book an Appointment
              </h1>
            </button>

            <button className='uppercase md:py-[9px] sm:py-[8px] py-[7px] lg:py-[11px] ps-[8px] pe-[15px] rounded-full border flex justify-center items-center group bg-[#330000] text-[#FFFFFF]'>
              <div className=' h-5 w-5  items-center justify-center flex'>
                <div
                  className='h-1 w-1 rounded-full bg-white duration-300 ease-in-out justify-center items-center flex'
                  style={{ backgroundColor: '#FFFFFF' }}
                ></div>
              </div>
              <h1 className=' font-barlowSemibold tracking-widest ps-2 text-[11px] mb-sm:text-[12.5px] mb-md:text-[13.5px] mb-lg:text-[15px] lg:text-[16px]'>
                customize your jewelry
              </h1>
            </button>
          </div>
        </div>
      )} */}

      {isOpen && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50'>
          <div className='bg-white rounded-lg shadow-lg relative lg:w-[60%] w-[90%]'>
            <button
              onClick={() => setOpen(false)}
              className='absolute top-3 right-3 bg-gray-200 p-1 rounded-full'
            >
              ✖
            </button>
            <br />
            <CalendlyEmbed />
          </div>
        </div>
      )}

      {/* <div className='mt-16'>
        {userPageLoading ? (
          <Loading
            classes={
              'flex-grow flex relative max-h-screen sm:min-h-[45px] mx-[30%] justify-center bg-[rgba(128,128,128,0.3)] !text-white'
            }
          />
        ) : (
          <h1 className='font-cambonExtraLight text-[20px] switch:text-[24px] md:text-[30px] lg:text-[48px] text-center text-brownOrange'>
            Designer
            <span className='font-cambonExtraLightItalic block md:inline ml-2'>
              In-Stock Rings
            </span>
          </h1>
        )}

        <ProductGridGlobal
          productList={productListStock?.data ?? []}
          className='h-full w-full px-2'
          gridClassName='max-h-[680px] md:px-16 mt-4'
          withScroll={true}
          cardClassName='w-full'
          mediaClassName='h-[239px] md:h-[450px]'
          descriptionClassName='text-[#EBE9DD] text-[12px]'
          titleClassName='uppercase text-[14px] md:text-[16px]'
          priceClassName='font-cambonRegular text-[18px] md:text-[20px]'
          desktopConfig={{
            slidesPerView: 4,
            spaceBetween: 20,
          }}
          mobileConfig={{
            slidesPerView: 2,
            spaceBetween: 0,
          }}
          borderConfig={{
            mobile: {
              enabled: true,
              width: '0.2px',
              color: 'loveAffair',
              position: {
                top: true,
                bottom: false,
                between: true,
              },
            },
          }}
        />

        <div className='flex justify-center mt-[24px]'>
          <TagButton
            text='Shop all in-stock rings'
            color='#FFFFFF'
            onClick={() =>
              router.push('/product-listing?subcategory=Instock Rings')
            }
          />
        </div>
      </div> */}

      <span className='py-4'></span>
      <VertelierExperienceEngagement
        normalTitle='Vertelier'
        italicTitle='Promises'
        page='home'
      />


      {/* {userPageLoading ? (
        <Loading
          classes={
            'flex-grow flex relative max-h-screen sm:min-h-[645px] bg-[rgba(128,128,128,0.3)] !text-white'
          }
        />
      ) : (
        <div className="bg-white bg-[url('/engagement/customize/custom_bg.png')] w-full switch:flex switch:h-auto h-[300px] max-h-[650px] transition-all duration-200 relative justify-between">
          <div className='flex flex-row justify-between items-center w-full'>
            <img
              src='/image_diamond_left.svg'
              className='flex w-[250px] mb-md:w-[280px] mb-lg:w-auto switch:w-[350px] md:w-[450px] lg:w-[600px] h-full  -ml-[100px] mb-md:-ml-[80px] mb-lg:-ml-[70px] switch:-ml-[20px] md:-ml-[60px] opacity-100'
              alt=''
            />
            <img
              src='/image_diamond_right.svg'
              className='flex w-[236px] mb-md:w-[260px] mb-lg:w-auto switch:w-[350px] md:w-[450px] lg:w-[600px] h-full -mr-[100px] mb-md:-mr-[80px] mb-lg:-mr-[70px] switch:-mr-[20px] md:-mr-[60px] opacity-100'
              alt=''
            />
          </div>
          <ScrollFade>
            <div className='h-full w-full absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center flex-col border'>
              <h1 className='text-black text-center font-cambonRegular md:text-[64px] text-[24px] mb-lg:text-[40px] lg:text-[60px] leading-[20px] sm:leading-[40px] md:leading-[40px] xl:text-[120px] lg:leading-[70px]'>
                Customize <br />
                <span className='font-cambonMediumItalic'>your ring</span>
              </h1>
              <p className='font-barlowRegular text-center text-black text-[12px] mb-md:text-[16px] mb-lg:text-[16px] text-[#EAE8DC] leading-[20px] sm:leading-[30px] mt-4 mb-2 max-w-[220px] sm:max-w-[400px] tracking-widest'>
                With Vertelier&apos;s Spectacular Upgrades, enhance your ring
                effortlessly.Send it back for a larger diamond that doubles its
                value.
              </p>

              <ButtonWithArrow
                title='Customizing your ring'
                position='center'
                color='#000'
              />
            </div>
          </ScrollFade>
        </div>
      )} */}

      <QuestionSection />
    </>
  );
};

export default HeroSection;
